import React from 'react';
import { Typography, Box } from '@mui/material';
import { useParams } from 'react-router-dom';

const ClassDetail: React.FC = () => {
  const { id } = useParams();
  return (
    <Box>
      <Typography variant="h4">Class Detail {id}</Typography>
    </Box>
  );
};

export default ClassDetail; 